(function() {
  'use strict';

  let allArticles = [];
  let displayedCount = 0;
  const ARTICLES_PER_PAGE = 12;

  // Load articles from hidden data div
  function loadArticlesFromData() {
    const dataContainer = document.getElementById('js-articles-data');
    if (!dataContainer) return [];

    const articleElements = dataContainer.querySelectorAll('.article-data');
    const articles = [];

    articleElements.forEach(el => {
      articles.push({
        id: el.dataset.id,
        title: el.dataset.title,
        url: el.dataset.url,
        created_at: parseInt(el.dataset.created),
        published_at: parseInt(el.dataset.published),
        date_display: el.dataset.dateDisplay,
        image: el.dataset.image,
        tags: el.dataset.tags ? el.dataset.tags.split(',').filter(t => t) : []
      });
    });

    return articles;
  }

  // Sort articles by created_at (newest first)
  function sortArticlesByDate(articles) {
    return articles.sort((a, b) => b.created_at - a.created_at);
  }

  // Render article card HTML
  function renderArticleCard(article) {
    const tags = article.tags.slice(0, 3).map(tag =>
      `<span class="tag">${tag.trim()}</span>`
    ).join('');

    return `
      <div class="article-card">
        ${article.image && article.image !== 'https:' ? `
          <div class="image-section">
            <a href="${article.url}">
              <img src="${article.image}" alt="${article.title}" loading="lazy">
            </a>
          </div>
        ` : ''}
        <div class="article-content">
          <div class="article-meta">
            <time class="time">${article.date_display}</time>
            ${tags ? `<span class="dot"> - </span>${tags}` : ''}
          </div>
          <h3><a href="${article.url}">${article.title}</a></h3>
          <a href="${article.url}" class="link--primary" title="Read More">Read More</a>
        </div>
      </div>
    `;
  }

  // Display next batch of articles
  function displayNextBatch() {
    const articleList = document.getElementById('js-article-list');
    if (!articleList) return false;

    const endIndex = Math.min(displayedCount + ARTICLES_PER_PAGE, allArticles.length);

    for (let i = displayedCount; i < endIndex; i++) {
      const li = document.createElement('li');
      li.innerHTML = renderArticleCard(allArticles[i]);
      articleList.appendChild(li);
    }

    displayedCount = endIndex;

    // Show/hide load more button
    const loadMoreBtn = document.getElementById('js-load-more');
    if (loadMoreBtn) {
      loadMoreBtn.style.display = displayedCount < allArticles.length ? 'block' : 'none';
    }

    return displayedCount < allArticles.length;
  }

  // Display featured article
  function displayFeaturedArticle() {
    if (allArticles.length === 0) return;

    const featuredContainer = document.getElementById('js-featured-article');
    if (!featuredContainer) return;

    const featured = allArticles[0];
    const tags = featured.tags.slice(0, 3).map(tag =>
      `<span class="tag">${tag.trim()}</span>`
    ).join('');

    featuredContainer.innerHTML = `
      <div class="featured-blog ipad-none">
        <div class="image-section">
          <a href="${featured.url}" class="link--primary" title="${featured.title}">
            ${featured.image && featured.image !== 'https:' ? `
              <img src="${featured.image}" alt="${featured.title}">
            ` : ''}
          </a>
        </div>
        <div class="content">
          <time class="time">${featured.date_display}</time>
          ${tags ? `<span class="dot"> - </span>${tags}` : ''}
          <h2>${featured.title}</h2>
          <a href="${featured.url}" class="link--primary" title="Read More">Read More</a>
        </div>
      </div>
      <div class="featured-blog ipad-block">
        <div class="image-section">
          <a href="${featured.url}" class="link--primary" title="${featured.title}">
            ${featured.image && featured.image !== 'https:' ? `
              <img src="${featured.image}" alt="${featured.title}">
            ` : ''}
          </a>
        </div>
        <div class="content">
          <time class="time">${featured.date_display}</time>
          ${tags ? `<span class="dot"> - </span>${tags}` : ''}
          <h2>${featured.title}</h2>
          <a href="${featured.url}" class="link--primary" title="Read More">Read More</a>
        </div>
      </div>
    `;
  }

  // Initialize lazy loading on scroll
  function initLazyLoading() {
    let isLoading = false;

    window.addEventListener('scroll', () => {
      if (isLoading) return;
      if (displayedCount >= allArticles.length) return;

      const scrollPosition = window.innerHeight + window.scrollY;
      const threshold = document.documentElement.scrollHeight - 800;

      if (scrollPosition > threshold) {
        isLoading = true;
        displayNextBatch();
        setTimeout(() => { isLoading = false; }, 100);
      }
    });
  }

  // Global function for load more button
  window.loadMoreArticles = function() {
    displayNextBatch();
  };

  // Main initialization
  function init() {
    const articleList = document.getElementById('js-article-list');
    if (!articleList) return;

    // Load articles from data attributes
    allArticles = loadArticlesFromData();

    if (allArticles.length === 0) {
      articleList.innerHTML = '<li style="width:100%; text-align:center; padding:40px;">No articles found.</li>';
      return;
    }

    // Sort by created_at (newest first)
    allArticles = sortArticlesByDate(allArticles);

    console.log(`Loaded ${allArticles.length} articles, sorted by creation date (newest first)`);
    console.log('First 3 articles:', allArticles.slice(0, 3).map(a => ({ title: a.title, created_at: a.created_at })));

    // Clear loading message
    articleList.innerHTML = '';

    // Display featured article
    displayFeaturedArticle();

    // Display first batch
    displayNextBatch();

    // Initialize lazy loading on scroll
    initLazyLoading();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
